(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssf-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const messages = document.querySelectorAll('.ssf-announcement-bar__message');
  if (messages.length <= 1) return;
  let current = 0;
  setInterval(function () {
    messages[current].classList.remove('is-active');
    current = (current + 1) % messages.length;
    messages[current].classList.add('is-active');
  }, 4000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssf-featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Mobile scroll dots
  const grids = document.querySelectorAll('.ssf-featured-products__grid');
  grids.forEach(function (grid) {
    const sectionId = grid.id.replace('ssf-products-', '');
    const dotsEl = document.getElementById('ssf-dots-' + sectionId);
    if (!dotsEl) return;

    const cards = grid.querySelectorAll('.ssf-product-card');
    if (!cards.length) return;

    // Build dots
    cards.forEach(function (_, i) {
      const dot = document.createElement('button');
      dot.className = 'ssf-scroll-dots__dot' + (i === 0 ? ' ssf-scroll-dots__dot--active' : '');
      dot.setAttribute('aria-label', 'Go to product ' + (i + 1));
      dot.addEventListener('click', function () {
        cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      dotsEl.appendChild(dot);
    });

    const dots = dotsEl.querySelectorAll('.ssf-featured-products__dot');

    // Observe active card
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const idx = Array.from(cards).indexOf(entry.target);
          dots.forEach(function (d) { d.classList.remove('ssf-scroll-dots__dot--active'); });
          if (dots[idx]) dots[idx].classList.add('ssf-scroll-dots__dot--active');
        }
      });
    }, { root: grid, threshold: 0.6 });

    cards.forEach(function (card) { io.observe(card); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
